import { DateTime } from 'luxon';
import { CouponGiftDTOOccasionEnum } from '../../../../../probonio-shared-ui/api';
import { fillNumberRangeArray } from '../../../util/numberRange';

export const GIFT_OCCASION_OPTIONS: CouponGiftDTOOccasionEnum[] = [
  CouponGiftDTOOccasionEnum.Birthday,
  CouponGiftDTOOccasionEnum.ChildBaptism,
  CouponGiftDTOOccasionEnum.ChildBirth,
  CouponGiftDTOOccasionEnum.ChildCommunion,
  CouponGiftDTOOccasionEnum.ChildConfirmationCath,
  CouponGiftDTOOccasionEnum.ChildConfirmationProt,
  CouponGiftDTOOccasionEnum.PassedExam,
  CouponGiftDTOOccasionEnum.SaintsDay,
  CouponGiftDTOOccasionEnum.Wedding,
  CouponGiftDTOOccasionEnum.WeddingGold,
  CouponGiftDTOOccasionEnum.WeddingSilver,
  CouponGiftDTOOccasionEnum.CompanyAnniversary,

  CouponGiftDTOOccasionEnum.Other,
];

export const INCENTIVE_OCCASION_OPTIONS: CouponGiftDTOOccasionEnum[] = [
  CouponGiftDTOOccasionEnum.Achievement,
  CouponGiftDTOOccasionEnum.Commitment,
  CouponGiftDTOOccasionEnum.WorkPerformance,
  CouponGiftDTOOccasionEnum.Proposal,
  CouponGiftDTOOccasionEnum.Recruitment,
  CouponGiftDTOOccasionEnum.Attendance,
  CouponGiftDTOOccasionEnum.SigningBonus,
  CouponGiftDTOOccasionEnum.ProfitSharing,

  CouponGiftDTOOccasionEnum.Other,
];

export const MAX_YEARLY_INCENTIVE_AMOUNT = 1000000;
export function giftYearlyAvailable(gift: CouponGiftDTOOccasionEnum): boolean {
  return (
    gift === CouponGiftDTOOccasionEnum.Birthday || gift === CouponGiftDTOOccasionEnum.SaintsDay || gift === CouponGiftDTOOccasionEnum.Other
  );
}

export function getNextBirthDay(birthDate?: string): DateTime | undefined {
  if (birthDate) {
    const nextBirthDay = DateTime.fromISO(birthDate).set({ year: DateTime.now().year });
    if (nextBirthDay < DateTime.now().startOf('day')) {
      return nextBirthDay.plus({ years: 1 });
    } else {
      return nextBirthDay;
    }
  }
}

export function getUpcomingGift(couponGifts: { payoutDate: string }[]): DateTime | undefined {
  if (couponGifts.length === 0) return;
  let minDate: DateTime | undefined;
  for (const couponGift of couponGifts) {
    const payoutDate = DateTime.fromISO(couponGift.payoutDate);
    // TODO calc status in backend
    if (payoutDate > DateTime.now())
      if (!minDate) {
        minDate = payoutDate;
      } else if (minDate > payoutDate) {
        minDate = payoutDate;
      }
  }
  return minDate;
}

const MIN = 500;
const MAX = 6000;
export const GIFT_BUDGET_OPTIONS = fillNumberRangeArray(MIN, MAX, 500).sort((a, b) => a - b);

export const INCENTIVE_BUDGET_OPTIONS = [
  ...fillNumberRangeArray(10_00, 500_00, 5_00),
  ...fillNumberRangeArray(550_00, 950_00, 50_00),
  ...fillNumberRangeArray(1000_00, 10_000_00, 100_00),
].sort((a, b) => a - b);
